import { Component, OnInit, ViewChild } from '@angular/core';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';
import { FilterView, FilterViewProviderDirective } from '@ntap/core';
import { MainListViewComponent } from '../main-listview/main-listview.component';

@Component({
  selector: 'app-pretraga-kataloga',
  templateUrl: './pretraga-kataloga.component.html',
  styleUrls: ['./pretraga-kataloga.component.css']
})
export class PretragaKatalogaComponent
  extends MainListViewComponent
  implements OnInit
{
  override INIT_COMP_ID =
    EarhivUiComponents.JEDINICA_GRADIVA_TABLE_LIST_GRID_VIEW;

  @ViewChild(FilterViewProviderDirective)
  filterViewProvider: FilterViewProviderDirective<FilterView>;

  tablica = [
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~razina',
    'en~jedinica_gradiva~vrijeme_nastanka_labela',
    'en~jedinica_gradiva~vrsta_sadrzaja',
    'en~jedinica_gradiva~status_obrade',
    'en~jedinica_gradiva~locked',
    'en~jedinica_gradiva~javno_objavljeno'
  ];

  lista = [
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~vrijeme_nastanka_labela',
    'en~jedinica_gradiva~razina',
    'en~jedinica_gradiva~autor',
    'en~jedinica_gradiva~mjesto_labela',
    'en~jedinica_gradiva~vrsta_sadrzaja'
  ];
  grid = [
    'en~jedinica_gradiva~arhivska_oznaka',
    'en~jedinica_gradiva~glavni_naziv',
    'en~jedinica_gradiva~content_id',
    'en~jedinica_gradiva~posjednik_naziv',
    'en~jedinica_gradiva~sadrzaj',
    'en~jedinica_gradiva~status_obrade',
    'en~jedinica_gradiva~javno_objavljeno',
    'en~jedinica_gradiva~prava_koristenja'
  ];

  override ngOnInit() {
    this.changeView('jedinica_gradiva');
  }
}
